import React from 'react';
import { WEIGHT_UNITS } from '../../features/deliveryItems/weightUnit';

/**
 * The check that switches bulto weights between kilos (the default) and grams.
 *
 * Display only: see `features/deliveryItems/weightUnit.js`. The backend always
 * gets grams.
 *
 * @param {object} props
 * @param {'kg'|'g'} props.unit
 * @param {(unit: 'kg'|'g') => void} props.onChange
 * @param {string} [props.className]
 */
export const WeightUnitToggle = ({ unit, onChange, className = '' }) => (
  <label className={`inline-flex items-center gap-2 text-xs text-text-secondary cursor-pointer select-none ${className}`}>
    <input
      type="checkbox"
      checked={unit === WEIGHT_UNITS.G}
      onChange={(e) => onChange(e.target.checked ? WEIGHT_UNITS.G : WEIGHT_UNITS.KG)}
      data-testid="weight-unit-toggle"
      className="rounded border-border text-ninja-green focus:ring-ninja-green"
    />
    Trabajar el peso en gramos
  </label>
);
